import gql from 'not-graphql-tag';

export const reportOutageBySpListGuestMutation = gql`
  mutation reportOutageBySpListGuest(
    $payload: ReportOutageBySpListGuestRequest!
  ) {
    reportOutageBySpListGuest(payload: $payload) {
      success
    }
  }
`;
export const reportOutageBySpListMutation = gql`
  mutation reportOutageBySpList($payload: ReportOutageBySpListRequest!) {
    reportOutageBySpList(payload: $payload) {
      success
    }
  }
`;
export const getOutageDetailsByZipCodeQuery = gql`
  query getOutageDetailsByZipCode($params: OutageDetailsByZipCodeParams!) {
    getOutageDetailsByZipCode(params: $params) {
      zipCode
      cause
      totalCustomersImpacted
      estimatedRestorationOn
      estimatedRestorationOut
      lat
      long
    }
  }
`;

export const getOutagesByCountyQuery = gql`
  query getOutagesByCounty($params: OutageByCountyParams) {
    getOutagesByCounty(params: $params)
  }
`;
export const getOutageEventDetailsQuery = gql`
  query getOutageEventDetails($params: OutageEventParams!) {
    getOutageEventDetails(params: $params) {
      totalCustomersImpacted
      crewDispatchedStatus
      estimatedTimeOut
      estimatedTimeOn
      cause
      lat
      long
      isStorm
      noOfReports
      eventStatus
    }
  }
`;

export const submitCommPreferenceMutation = gql`
  mutation submitCommPreference($payload: SubmitCommPreferencesRequest!) {
    submitCommPreferences(payload: $payload) {
      success
    }
  }
`;

export const getContactDetails = gql`
  query getAccountInfo {
    getAccountInfo {
      contactDetails {
        encryptedContactId
        contactType
        contactValue
        isPrimary
      }
    }
  }
`;
